// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root___t7w4"};